var exports = {
  "vK": "PremiumUpsellBanner.module__banner___c3plcG",
  "Qs": "PremiumUpsellBanner.module__content___c3plcG",
  "Qq": "PremiumUpsellBanner.module__text___c3plcG",
  "Wz": "PremiumUpsellBanner.module__communityRow___c3plcG",
  "ju": "PremiumUpsellBanner.module__communityIcon___c3plcG",
  "nG": "PremiumUpsellBanner.module__communityMore___c3plcG",
  "rT": "PremiumUpsellBanner.module__previewRow___c3plcG",
  "kH": "PremiumUpsellBanner.module__previewItem___c3plcG",
  "yY": "PremiumUpsellBanner.module__previewEmojiText___c3plcG",
};

module.exports = exports;
